import { render, staticRenderFns } from "./UpskillCareer.vue?vue&type=template&id=3081ae49&scoped=true"
import script from "./UpskillCareer.vue?vue&type=script&lang=ts"
export * from "./UpskillCareer.vue?vue&type=script&lang=ts"
import style0 from "./UpskillCareer.vue?vue&type=style&index=0&id=3081ae49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081ae49",
  null
  
)

export default component.exports